/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './dismissMatch.defs'
export { main as default } from './dismissMatch.defs'
